import { ArrowLeft, ArrowRight } from 'lucide-react'
import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'

interface FillStepFooterProps {
  /** Left out on the last tab, where Send to carriers is the way on. */
  label?: string
  onContinue?: () => void
  /** Left out on the first tab. */
  onBack?: () => void
  saving?: boolean
  /** Given while the tab has unsaved edits: Discard shows beside the button. */
  onDiscard?: () => void
  /** Shown beside the button, e.g. that files are still being read. */
  note?: ReactNode
}

export function FillStepFooter({
  label,
  onContinue,
  onBack,
  saving = false,
  onDiscard,
  note,
}: FillStepFooterProps) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div>
        {onBack && (
          <Button type="button" variant="outline" className="text-md" onClick={onBack}>
            <ArrowLeft /> Back
          </Button>
        )}
      </div>
      <div className="flex flex-wrap items-center justify-end gap-3">
        {note && <span className="text-ink-500 text-sm">{note}</span>}
        {onDiscard && (
          <Button type="button" variant="outline" className="text-md" onClick={onDiscard} disabled={saving}>
            Discard
          </Button>
        )}
        {label && onContinue && (
          <Button
            type="button"
            className="text-md"
            onClick={onContinue}
            loading={saving ? 'Saving…' : undefined}
          >
            {label} <ArrowRight />
          </Button>
        )}
      </div>
    </div>
  )
}
